module.exports = __webpack_public_path__ + "media/images/sales/nanairoweek/price-set-c1b837032a2d8a394e48551ff46dae99.svg";